import React from "react";
import {
  ErrorFallbackContainer,
  ErrorMessage,
  RetryButton,
} from "./ClaimErrorBoundary.style";

interface ErrorBoundaryProps {
  fallback?: React.ReactNode;
  onReset?: () => void;
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ClaimErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("ClaimErrorBoundary caught:", error, info.componentStack);
  }

  handleReset = () => {
    this.setState({ hasError: false });
    this.props.onReset?.();
  };

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <ErrorFallbackContainer>
          <ErrorMessage>Something went wrong. Please try again.</ErrorMessage>
          <RetryButton onClick={this.handleReset} type="button">
            Try Again
          </RetryButton>
        </ErrorFallbackContainer>
      );
    }

    return this.props.children;
  }
}
